import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      paddingTop: spacing(3)
    }
  },
  dialogTitle: {
    padding: spacing(2.5),
    paddingBottom: spacing(1.5)
  },
  dialogContent: {
    padding: spacing(3, 2.5, 3, 2.5),
    '&.MuiDialogContent-root': {
      paddingTop: spacing(1)
    }
  },
  dialogSubtitle: {
    marginTop: spacing(1)
  },
  sectionCard: {
    height: '100%',
    transition: 'all 0.15s ease-in-out',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
      borderColor: palette.primary?.main || '#1976d2'
    }
  },
  cardContent: {
    padding: spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing(2)
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 24,
    // Background color will be set via CSS custom property in the component
    backgroundColor: 'var(--section-type-color, #1976d2)'
  },
  cardTitle: {
    fontWeight: 600,
    marginBottom: spacing(0.5),
    fontSize: '1rem'
  },
  cardDescription: {
    lineHeight: 1.4,
    fontSize: '0.875rem'
  },
  cardTextContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  selectedCard: {
    borderColor: `${palette.primary?.main || '#1976d2'} !important`,
    borderWidth: '2px !important',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
  },
  previewContainer: {
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: 8,
    height: 470,
    maxHeight: 470,
    minHeight: 470,
    overflow: 'hidden',
    backgroundColor: palette.grey?.[50] || '#fafafa',
    display: 'flex',
    flexDirection: 'column'
  },
  emptyPreview: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(1)
  },
  previewTabs: {
    backgroundColor: palette.background?.paper || '#fff',
    borderBottom: `1px solid ${palette.divider || '#e0e0e0'}`,
    flexShrink: 0,
    '& .MuiTab-root': {
      minWidth: 120,
      fontSize: '0.875rem',
      textTransform: 'none',
      gap: spacing(0.5),
      padding: spacing(1, 2),
      '& .MuiSvgIcon-root': {
        fontSize: '1rem',
        opacity: 0.7
      }
    },
    '& .MuiTabs-indicator': {
      height: 3,
      borderRadius: '2px 2px 0 0'
    }
  },
  previewImageContainer: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(2),
    boxSizing: 'border-box'
  },
  previewImage: {
    objectFit: 'contain',
    backgroundColor: palette.background?.paper || '#fff',
    display: 'block',
    objectPosition: 'center',
    borderRadius: spacing(0.5),
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
  },
  desktopPreviewImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto'
  },
  mobilePreviewImage: {
    maxWidth: '100%',
    maxHeight: '280px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain'
  },
  previewFallback: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.grey?.[100] || '#f5f5f5'
  },
  addButtonContainer: {
    marginTop: spacing(4)
  },
  sectionTypeHeader: {
    marginBottom: spacing(2)
  },
  sectionTypeTitle: {
    fontWeight: 600
  },
  previewHeader: {
    marginBottom: spacing(2),
    fontWeight: 600
  },
  previewTabsContainer: {
    marginBottom: spacing(2)
  },
  previewFallbackContainer: {
    display: 'flex'
  },
  clickableCard: {
    cursor: 'pointer'
  }
}))
